export const Overline = ({ children, className = "", light = false }) => (
  <span className={`block text-xs tracking-[0.3em] uppercase mb-4 ${light ? "text-gold" : "text-gold-dark"} ${className}`}>
    <span className="inline-flex items-center gap-3">
      <span className="h-px w-8 bg-gold/60" />
      {children}
    </span>
  </span>
);
